import Sections from '~/constants/sections';
import * as types from './actionTypes';

export const setSectionMounted = (payload: string) => ({
  type: types.SET_SECTION_MOUNTED,
  payload
});

export const setSectionViewed = (payload: Sections) => ({
  type: types.SET_SECTION_VIEWED,
  payload
});

export const setDisableSpinner = (payload: boolean) => ({
  type: types.SET_DISABLE_SPINNER,
  payload
});

export const setLazyLoad = (payload: boolean) => ({
  type: types.SET_LAZY_LOAD,
  payload
});
